import React from 'react';
import styled from 'styled-components';
import { RADIUS } from '../radius/radius';
import {
  COLOR_BACKGROUND_LIGHT,
  COLOR_TEXT_INVERSE,
  COLOR_TEXT_PRIMARY,
} from '../colors/colors';

const StyledButton = styled.button`
  width: 100%;
  padding: 16px 24px;
  border: none;
  border-radius: ${RADIUS.SM};
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;

  background: ${({ variant }) =>
    variant === 'secondary' ? COLOR_BACKGROUND_LIGHT : COLOR_TEXT_PRIMARY};
  color: ${({ variant }) =>
    variant === 'secondary' ? COLOR_TEXT_PRIMARY : COLOR_TEXT_INVERSE};

  &:hover {
    opacity: 0.9;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  &:active {
    transform: scale(0.98);
  }
`;

export const YouButton = ({ children, variant = 'primary', ...props }) => {
  return (
    <StyledButton variant={variant} {...props}>
      {children}
    </StyledButton>
  );
};
